export const BAD_REQUEST_STATUS_CODE = 400;
export const OK_STATUS_CODE = 200;
export const IN_ACTIVITY_TIMEOUT = 10 * 60 * 1000 // 10 Minutes